import { render } from "./EventoForm.vue?vue&type=template&id=4d2af651&scoped=true"
import script from "./EventoForm.vue?vue&type=script&lang=js"
export * from "./EventoForm.vue?vue&type=script&lang=js"

import "./EventoForm.vue?vue&type=style&index=0&id=4d2af651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2af651"]])

export default __exports__